function fetchConfig () {
  return {
    headers: {
      token: window.BARREL.sbdApiAccessToken
    }
  }
}

async function fetchAPI (path, config) {
  const url = new URL(window.BARREL.sbdApiUrl)
  url.pathname = path

  const response = await fetch(url, config)

  if (response.ok) {
    return response.json()
  }
  return response.text().then(text => {throw new Error(text)})
}

export async function getProducts () {
  const config = fetchConfig()
  config.headers['Content-Type'] = 'application/json'

  return fetchAPI(`/api/productRegistration/products/${window.BARREL.customerId}`, config)
}

export async function registerProduct (payload) {
  const config = fetchConfig()
  config.method = 'POST'
  config.headers['Content-Type'] = 'application/json'
  config.body = JSON.stringify(payload)

  return fetchAPI(`/api/productRegistration/register/${window.BARREL.customerId}`, config)
}

export async function updateProductNickname (payload) {
  const config = fetchConfig()
  config.method = 'PUT'
  config.headers['Content-Type'] = 'application/json'
  config.body = JSON.stringify(payload)

  return fetchAPI(`/api/productRegistration/updateToolNickname/${window.BARREL.customerId}`, config)
}

export async function getProofOfPurchase (registeredGUID) {
  const config = fetchConfig()
  config.method = 'GET'
  config.headers['Content-Type'] = 'application/json'
  const params = new URLSearchParams({
    token: window.BARREL.sbdApiAccessToken,
    registeredGUID: registeredGUID
  })

  return fetchAPI(`/api/productRegistration/proofOfPurchase/${window.BARREL.customerId}?${params}`, config)
}

export async function deleteProductRegistration (payload) {
  const config = fetchConfig()
  config.method = 'DELETE'
  config.headers['Content-Type'] = 'application/json'
  config.body = JSON.stringify(payload)

  return fetchAPI(`/api/productRegistration/delete/${window.BARREL.customerId}`, config)
}

export async function getInstructionManuals(sku) {
  const config = fetchConfig()
  config.method = 'GET'
  config.headers['Content-Type'] = 'application/json'
  const params = new URLSearchParams({
    token: window.BARREL.sbdApiAccessToken
  })

  return fetchAPI(`/api/productRegistration/instructionManuals/${sku}?token=${window.BARREL.sbdApiAccessToken}`, config)
}
